"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _AuthContext = require("../context/AuthContext");
var _ContentContainer = _interopRequireDefault(require("../components/rules-list/ContentContainer"));
var _RulesListContainer = _interopRequireDefault(require("../components/rules-list/RulesListContainer"));
var _webApi = require("../utils/web-api");
var _PageContext = require("../context/PageContext");
var _materialSymbols = require("@design/icons/material-symbols");
var _filterHeader = require("@common/components/filter-header");
var _CreatePlaybookModal = _interopRequireDefault(require("../components/rule-details/CreatePlaybookModal"));
var _button = require("@design/ui/button");
var _AnalyticsContext = require("../context/AnalyticsContext");
var _useOrgFeatureFlag = _interopRequireDefault(require("../hooks/useOrgFeatureFlag"));
var _foldedTextSearch = require("@common/utils/foldedTextSearch");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var PlaybooksContainer = _styledComponents.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"])));
var PlaybookCard = _styledComponents.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n  background: #FFFFFF;\n  border: 1px solid #EDEBE8;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    border-color: var(--border-hover);\n  }\n"])));
var PlaybookHeader = _styledComponents.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n"])));
var PlaybookName = _styledComponents.styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.3;\n  letter-spacing: 0.01em;\n  color: #555555;\n  flex: 1;\n"])));
var PlaybookDescription = _styledComponents.styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-size: 12px;\n  color: #6B7280;\n  line-height: 1.3;\n  margin-top: 2px;\n"])));
var PlaybookMeta = _styledComponents.styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 2px;\n"])));
var PlaybookMetaItem = _styledComponents.styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-style: normal;\n  font-size: 11px;\n  color: #6B7280;\n"])));
var formatStatus = function formatStatus(status, isGlobalPlaybook) {
  if (isGlobalPlaybook) return 'Global';
  if (!status) return 'Unknown';
  return status.split('_').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
};
var getStatusStyles = function getStatusStyles(status, isGlobalPlaybook) {
  if (isGlobalPlaybook) {
    return {
      background: '#FEF3C7',
      color: '#92400E'
    };
  }
  if (status === 'active') {
    return {
      background: '#ECFDF5',
      color: '#059669'
    };
  }
  if (status === 'draft') {
    return {
      background: '#FEF3C7',
      color: '#92400E'
    };
  }
  return {
    background: '#FEF2F2',
    color: '#DC2626'
  };
};
var PlaybookStatus = _styledComponents.styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !["status", "isGlobalPlaybook"].includes(prop);
  }
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  padding: 1px 6px;\n  border-radius: 3px;\n  font-style: normal;\n  font-size: 11px;\n  font-weight: 500;\n  background: ", ";\n  color: ", ";\n"])), function (props) {
  return getStatusStyles(props.status, props.isGlobalPlaybook).background;
}, function (props) {
  return getStatusStyles(props.status, props.isGlobalPlaybook).color;
});
var LoadingMessage = _styledComponents.styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-size: 14px;\n  color: #6B7280;\n  text-align: center;\n  padding: 24px;\n"])));
var ErrorMessage = _styledComponents.styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-size: 14px;\n  color: #DC2626;\n  text-align: center;\n  padding: 24px;\n"])));
var BottomButtonsContainer = _styledComponents.styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 8px;\n  width: 100%;\n  margin-top: 16px;\n"])));
var MyPlaybooksPage = function MyPlaybooksPage() {
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    playbooks = _useState2[0],
    setPlaybooks = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = (0, _react.useState)(""),
    _useState8 = _slicedToArray(_useState7, 2),
    searchQuery = _useState8[0],
    setSearchQuery = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState0 = _slicedToArray(_useState9, 2),
    statusFilter = _useState0[0],
    setStatusFilter = _useState0[1];
  var _useState1 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState1, 2),
    typeFilter = _useState10[0],
    setTypeFilter = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    showCreatePlaybookModal = _useState12[0],
    setShowCreatePlaybookModal = _useState12[1];
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    accessToken = _useAuthInfo.accessToken;
  var _usePage = (0, _PageContext.usePage)(),
    showPage = _usePage.showPage;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    sendError = _useAnalytics.sendError;
  var isCreateOldPlaybookEnabled = (0, _useOrgFeatureFlag.default)("is_create_old_playbook_enabled");
  var filterSections = [{
    title: "Status",
    options: [{
      label: "Active",
      value: "active"
    }, {
      label: "Draft",
      value: "draft"
    }, {
      label: "Archived",
      value: "archived"
    }],
    selectedValues: statusFilter,
    onSelectedValuesChange: setStatusFilter
  }, {
    title: "Type",
    options: [{
      label: "Global",
      value: "global"
    }, {
      label: "Custom",
      value: "custom"
    }],
    selectedValues: typeFilter,
    onSelectedValuesChange: setTypeFilter
  }];
  (0, _react.useEffect)(function () {
    var loadPlaybooks = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, sortedPlaybooks, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (accessToken) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              setIsLoading(true);
              setError(null);
              _context.n = 2;
              return (0, _webApi.fetchPlaybooks)("Token ".concat(accessToken));
            case 2:
              data = _context.v;
              if (data) {
                sortedPlaybooks = _toConsumableArray(data).sort(function (a, b) {
                  if (a.status === 'active' && b.status !== 'active') return -1;
                  if (a.status !== 'active' && b.status === 'active') return 1;
                  return a.name.localeCompare(b.name);
                });
                setPlaybooks(sortedPlaybooks);
              } else {
                setError("Failed to load playbooks");
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error("Failed to load playbooks:", _t);
              sendError(_t, {
                component: "MyPlaybooksPage",
                action: "load_playbooks"
              });
              setError("Failed to load playbooks");
            case 4:
              _context.p = 4;
              setIsLoading(false);
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function loadPlaybooks() {
        return _ref.apply(this, arguments);
      };
    }();
    loadPlaybooks();
  }, []);
  var filteredPlaybooks = (0, _react.useMemo)(function () {
    return playbooks.filter(function (playbook) {
      if (!playbook || !playbook.name) return false;
      if (!(0, _foldedTextSearch.matchesSearch)(playbook.name, searchQuery)) {
        return false;
      }
      if (statusFilter.length > 0) {
        var playbookStatus = playbook.status || "unknown";
        if (!statusFilter.includes(playbookStatus)) {
          return false;
        }
      }
      if (typeFilter.length > 0) {
        var isGlobal = playbook.isGlobalPlaybook;
        var playbookType = isGlobal ? "global" : "custom";
        if (!typeFilter.includes(playbookType)) {
          return false;
        }
      }
      return true;
    });
  }, [playbooks, searchQuery, statusFilter, typeFilter]);
  var handlePlaybookClick = function handlePlaybookClick(playbook) {
    if (playbook.status !== 'active') return;
    showPage(_PageContext.PAGES.playbookPage, {
      playbookId: playbook.id,
      returnPage: _PageContext.PAGES.myPlaybooksPage
    });
  };
  var handleCreatePlaybookSuccess = function handleCreatePlaybookSuccess(playbookId) {
    var loadPlaybooks = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, sortedPlaybooks, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (accessToken) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return (0, _webApi.fetchPlaybooks)("Token ".concat(accessToken));
            case 2:
              data = _context2.v;
              if (data) {
                sortedPlaybooks = _toConsumableArray(data).sort(function (a, b) {
                  if (a.status === 'active' && b.status !== 'active') return -1;
                  if (a.status !== 'active' && b.status === 'active') return 1;
                  return a.name.localeCompare(b.name);
                });
                setPlaybooks(sortedPlaybooks);
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error("Failed to refresh playbooks after creation:", _t2);
              sendError(_t2, {
                component: "MyPlaybooksPage",
                action: "refresh_playbooks_after_creation",
                playbookId: playbookId
              });
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }));
      return function loadPlaybooks() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadPlaybooks();
  };
  if (isLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentContainer.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(LoadingMessage, {
        children: "Loading playbooks..."
      })
    });
  }
  if (error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentContainer.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(ErrorMessage, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ErrorIcon, {
          width: 16,
          height: 16,
          style: {
            marginRight: 8
          }
        }), error]
      })
    });
  }
  var createPlaybookSection = isCreateOldPlaybookEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(BottomButtonsContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_button.Button, {
        className: "flex-1",
        onClick: function onClick() {
          return setShowCreatePlaybookModal(true);
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddIcon, {
          width: 16,
          height: 16
        }), "Create Playbook"]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CreatePlaybookModal.default, {
      isOpen: showCreatePlaybookModal,
      onClose: function onClose() {
        return setShowCreatePlaybookModal(false);
      },
      onSuccess: handleCreatePlaybookSuccess
    })]
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ContentContainer.default, {
    className: "p-2",
    "data-sentry-element": "ContentContainer",
    "data-sentry-component": "MyPlaybooksPage",
    "data-sentry-source-file": "MyPlaybooksPage.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_RulesListContainer.default, {
      "data-sentry-element": "RulesListContainer",
      "data-sentry-source-file": "MyPlaybooksPage.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          width: '100%',
          marginBottom: '16px'
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_filterHeader.FilterHeader, {
          searchQuery: searchQuery,
          onSearchQueryChange: setSearchQuery,
          searchPlaceholder: "Search playbooks\u2026",
          filterSections: filterSections,
          "data-sentry-element": "FilterHeader",
          "data-sentry-source-file": "MyPlaybooksPage.tsx"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(PlaybooksContainer, {
        "data-sentry-element": "PlaybooksContainer",
        "data-sentry-source-file": "MyPlaybooksPage.tsx",
        children: [filteredPlaybooks.map(function (playbook) {
          return /*#__PURE__*/(0, _jsxRuntime.jsxs)(PlaybookCard, {
            onClick: function onClick() {
              return handlePlaybookClick(playbook);
            },
            style: {
              opacity: playbook.status === 'active' ? 1 : 0.6
            },
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(PlaybookHeader, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(PlaybookName, {
                children: playbook.name
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaybookStatus, {
                status: playbook.status,
                isGlobalPlaybook: playbook.isGlobalPlaybook,
                children: formatStatus(playbook.status, playbook.isGlobalPlaybook)
              })]
            }), playbook.description && /*#__PURE__*/(0, _jsxRuntime.jsx)(PlaybookDescription, {
              children: playbook.description
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(PlaybookMeta, {
              children: [playbook.isGlobalPlaybook && /*#__PURE__*/(0, _jsxRuntime.jsxs)(PlaybookMetaItem, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.LanguageIcon, {
                  width: 12,
                  height: 12
                }), "Global Playbook"]
              }), playbook.issueCount !== undefined && /*#__PURE__*/(0, _jsxRuntime.jsxs)(PlaybookMetaItem, {
                children: [playbook.issueCount, " ", playbook.issueCount === 1 ? 'Issue' : 'Issues']
              })]
            })]
          }, playbook.id);
        }), filteredPlaybooks.length === 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(LoadingMessage, {
          children: "No playbooks found"
        })]
      })]
    }), createPlaybookSection]
  });
};
var _default = exports.default = MyPlaybooksPage;